// src/theme/theme.js
import { createTheme } from '@mui/material/styles';

// Brand Colors
const brandColors = {
  // Primary colors
  black: '#000000',
  blackLight: '#232323',
  white: '#FFFFFF',
  blueMain: '#00b2fc',
  lemon: '#d9f316',
  
  // Secondary blue colors
  blueRightRight: '#3ed0fc',
  blueRightTop: '#86dffd',
  blueRightBottom: '#00c2fc',
  blueLeftTop: '#0088b6',
  blueLeftLeft: '#005a72',
  blueLeftBottom: '#002b34',
};

// Common theme settings
const commonSettings = {
  typography: {
    fontFamily: '"Poppins", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Montserrat", "Open Sauce", sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Montserrat", "Open Sauce", sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Montserrat", "Open Sauce", sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Montserrat", "Open Sauce", sans-serif',
      fontWeight: 700,
    },
    h5: {
      fontFamily: '"Montserrat", "Open Sauce", sans-serif',
      fontWeight: 700,
    },
    h6: {
      fontFamily: '"Montserrat", "Open Sauce", sans-serif',
      fontWeight: 700,
    },
    subtitle1: {
      fontWeight: 600,
    },
    subtitle2: {
      fontWeight: 600,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
        containedPrimary: {
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0, 178, 252, 0.3)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          overflow: 'hidden',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        },
      },
    },
  },
};

// Light theme
export const lightTheme = createTheme({
  ...commonSettings,
  palette: {
    mode: 'light',
    primary: {
      main: brandColors.blueMain,
      light: brandColors.blueRightTop,
      dark: brandColors.blueLeftTop,
      contrastText: brandColors.white,
    },
    secondary: {
      main: brandColors.lemon,
      contrastText: brandColors.blackLight,
    },
    background: {
      default: '#f8f9fa',
      paper: brandColors.white,
    },
    text: {
      primary: brandColors.blackLight,
      secondary: 'rgba(0, 0, 0, 0.6)',
    },
    divider: 'rgba(0, 0, 0, 0.08)',
    action: {
      hover: 'rgba(0, 178, 252, 0.08)',
      selected: 'rgba(0, 178, 252, 0.12)',
    },
  },
});

// Dark theme
export const darkTheme = createTheme({
  ...commonSettings,
  palette: {
    mode: 'dark',
    primary: {
      main: brandColors.blueMain,
      light: brandColors.blueRightTop,
      dark: brandColors.blueLeftTop,
      contrastText: brandColors.white,
    },
    secondary: {
      main: brandColors.lemon,
      contrastText: brandColors.blackLight,
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#f8f9fa',
      secondary: 'rgba(255, 255, 255, 0.7)',
    },
    divider: 'rgba(255, 255, 255, 0.08)',
    action: {
      hover: 'rgba(0, 178, 252, 0.15)',
      selected: 'rgba(0, 178, 252, 0.2)',
    },
  },
});

export default {
  light: lightTheme,
  dark: darkTheme,
  brandColors
};